import axios from 'axios';
import * as CONFIG from '../config/index';
export const RATING_API_URL = `${CONFIG.API_URL}/rating`;
export const GET_USER_RATED_VALUE_API_URL = `${RATING_API_URL}/get-rated`

export const getRating = async (ipId) => {
  const res = await axios.get(`${RATING_API_URL}?contentId=${ipId}`)
  return res.data
}

export const ratingIP = async (ipId, rateNum) => {
  const res = await axios.post(`${RATING_API_URL}`, {contentId: ipId, rateNum: rateNum})
}

export const getUserRated = async (ipId) => {
  return (await axios.get(`${GET_USER_RATED_VALUE_API_URL}?contentId=${ipId}`)).data
}

export default {
  ratingIP,
  getRating,
  getUserRated
}


// WEBPACK FOOTER //
// ./src/common/rating.js